import { render, staticRenderFns } from "./rechargeReward.vue?vue&type=template&id=264edc67&scoped=true"
import script from "./rechargeReward.vue?vue&type=script&lang=js"
export * from "./rechargeReward.vue?vue&type=script&lang=js"
import style0 from "./rechargeReward.vue?vue&type=style&index=0&id=264edc67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264edc67",
  null
  
)

export default component.exports